// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1SPkK","gridInput":"styles_gridInput__3Grtv","submitButton":"styles_submitButton__2-S1F"};